import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './ToggleSwitch.scss';

function ToggleSwitch({
  className = '',
  toggleClassName = '',
  textClassName = '',
  backgroundClassName = '',
  textLeft = '',
  textRight = '',
  tabIndex = 0,
  isActive = false,
  disabled = false,
  displayOnly = false,
  direction = 'horizontal',
  onToggle = () => {},
}) {
  const [active, setActive] = useState(isActive);
  // When displayOnly is true, ignore disabled prop
  const isDisabled = displayOnly ? false : disabled;

  const onToggleClick = () => {
    if (!isDisabled && !displayOnly) {
      setActive(!active);
      onToggle(!active);
    }
  };

  const onKeyboardToggle = (e) => {
    if (e.key !== 'Enter' && e.code !== 'Space') {
      return;
    }
    if (!isDisabled && !displayOnly) {
      e.preventDefault();
      onToggleClick();
    }
  };

  useEffect(() => {
    // Allows Toggle Switch to be controlled by external sources
    setActive(isActive);
  }, [isActive]);

  if (displayOnly) {
    return (
      <div className={`ToggleSwitch ToggleSwitch--${direction} ToggleSwitch--displayOnly ${className}`}>
        {textLeft && (
          <span
            className={`ToggleSwitch-text ToggleSwitch-textLeft ToggleSwitch-textLeft--${direction} ${textClassName}`}
          >
            {textLeft}
          </span>
        )}
        <div className={`ToggleSwitch-displayValue ${active ? 'ToggleSwitch-displayValue--active' : ''}`}>
          {active ? 'Yes' : 'No'}
        </div>
        {textRight && (
          <span
            className={`ToggleSwitch-text ToggleSwitch-textRight ToggleSwitch-textRight--${direction} ${textClassName}`}
          >
            {textRight}
          </span>
        )}
      </div>
    );
  }

  return (
    <div className={`ToggleSwitch ToggleSwitch--${direction} ${className}`}>
      {textLeft && (
        <span
          className={`ToggleSwitch-text ToggleSwitch-textLeft ToggleSwitch-textLeft--${direction} ${textClassName}`}
        >
          {textLeft}
        </span>
      )}
      <div
        className={`ToggleSwitch-background ${active ? 'ToggleSwitch--active' : ''} ${
          isDisabled ? 'disabled' : ''
        } ${backgroundClassName}`}
        tabIndex={tabIndex}
        onKeyDown={onKeyboardToggle}
        onClick={onToggleClick}
      >
        <div className={`ToggleSwitch-toggle ${toggleClassName}`} />
      </div>
      {textRight && (
        <span
          className={`ToggleSwitch-text ToggleSwitch-textRight ToggleSwitch-textRight--${direction} ${textClassName}`}
        >
          {textRight}
        </span>
      )}
    </div>
  );
}

ToggleSwitch.propTypes = {
  className: PropTypes.string,
  direction: PropTypes.string, // vertical, horizontal
  toggleClassName: PropTypes.string,
  textClassName: PropTypes.string,
  backgroundClassName: PropTypes.string,
  tabIndex: PropTypes.number,
  isActive: PropTypes.bool,
  disabled: PropTypes.bool,
  displayOnly: PropTypes.bool,
  onToggle: PropTypes.func,
  textLeft: PropTypes.string,
  textRight: PropTypes.string,
};

export default ToggleSwitch;
